import { Button, ButtonProps } from "@fluentui/react-components";
import { Field, FieldProps } from "formik";

import React from "react";
import { observer } from "mobx-react";

const M365PulseFormSubmitButtonBase = ({ children, disabled, ...restProps }: ButtonProps) => (
    <Field>
        {({ form: { isSubmitting, isValid } }: FieldProps) => (
            <Button type="submit" disabled={isSubmitting || disabled || !isValid} {...restProps}>
                {children}
            </Button>
        )}
    </Field>
);

export const M365PulseFormSubmitButton = observer(M365PulseFormSubmitButtonBase);
